import * as types from "../../mutation-types.js";
import http from "@service/http";
import util from "@common/utils/util";

const DIY_GROUPS = "DIY_GROUPS"; //系列
const DIY_FLOWERS = "DIY_FLOWERS"; //花型
const DIY_COLORS = "DIY_COLORS"; //颜色
const DIY_DOORS = "DIY_DOORS"; //门体
const DIY_FITTINGS = "DIY_FITTINGS"; // 配件
const DIY_SHOW_IMAGES = "DIY_SHOW_IMAGES"; //diy展示的图片
const GOOD_DETAIL = "GOOD_DETAIL"; //diy详情
const ADD_SPEC_PRICE = "ADD_SPEC_PRICE";

/**
 * 分类 STORE
 */
export default {
  state: {
    diyGroups: {}, //系列
    diyFlowers: {}, //花型
    diyColors: {}, //颜色
    diyDoors: {}, //门体
    diyFittings: [], // 配件
    diyShowImages: [], //diy展示的图片
    diyTotalPrice: 0, // 选中的价格
    finalSelect: {
      doorInstMsg: {},
      specs: [],
      fittings: [],
    },
    goodsDetails: [], //diy详情
  },
  actions: {
    // 获取diy信息 (无参数）
    getDiyInfos({ commit }, diyInfo) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDiyInfo",
          param: diyInfo,
        })
        .then((result) => {
          console.log("result", result);
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            const list = result.target.target;
            commit("DIY_GROUPS", { list: list.groups || {} });
            commit("DIY_DOORS", { list: list.doors || {} });
            commit("DIY_FITTINGS", { list: list.fittings || [] });
            commit("DIY_COLORS", { list: list.colors || {} });
            commit("DIY_FLOWERS", { list: list.flowers || {} });
            commit("DIY_SHOW_IMAGES");
            return Promise.resolve(list);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 根据系列获取diy信息
    getDoorInfo({ commit }, diyInfo) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDoorInfo",
          param: diyInfo,
        })
        .then((result) => {
          console.log("result", result);
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            const list = result.target.target;
            commit("DIY_DOORS", { list: list.doors || {} });
            commit("DIY_FITTINGS", { list: list.fittings || [] });
            commit("DIY_COLORS", { list: list.colors || {} });
            commit("DIY_FLOWERS", { list: list.flowers || {} });
            commit("DIY_SHOW_IMAGES");
            return Promise.resolve(list);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 刷新门体，规格，配件
    getDoorInstInfo({ commit }, diyInfo) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDoorInstInfo",
          param: diyInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            const list = result.target.target;
            commit("DIY_DOORS", { list: list.doors || {} });
            commit("DIY_FITTINGS", { list: list.fittings || [] });
            commit("DIY_SHOW_IMAGES");
            return Promise.resolve(list);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 获取门体规格
    getSpecInfo({ commit }, diyInfo) {
      return http
        .post({
          fn: "mallsale.diyHandler.getSpecInfo",
          param: diyInfo,
        })
        .then((result) => {
          console.log("result", result);
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            const list = result.target.target;
            commit("DIY_FITTINGS", { list: list.fittings || [] });
            commit("DIY_SHOW_IMAGES");
            return Promise.resolve(list);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //加入diy到购物车
    addMemCartDiyPage({ commit }, data) {
      return http
        .post({
          fn: "mallsale.diyHandler.addMemCart",
          param: data,
        })
        .then((result) => {
          if (result && result.success) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject(
              (result && result.message) || "添加购物车失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //直接购买diy（商品diy入口）
    getOrderSettleMsgDiyPage({ commit }, goodsInfo) {
      console.log("goodsInfo", goodsInfo);
      return http
        .post({
          fn: "mallsale.settleHandler.getOrderSettleMsgForDiy",
          param: goodsInfo,
        })
        .then((result) => {
          console.log("result>>>", result);
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 获取diy详情
    getDiyDetail({ commit }) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDiyDetail",
          param: [0],
        })
        .then((result) => {
          console.log("result", result);
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            console.log(result.target.target);
            commit("GOOD_DETAIL", result.target.target);
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    handleSelectChange({ commit }, { diyName, item, index }) {
      switch (diyName) {
        case "GROUPS":
          commit("DIY_GROUPS", { index: index });
          break;
        case "DOORS":
          commit("DIY_DOORS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "COLORS":
          commit("DIY_COLORS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "FLOWERS":
          commit("DIY_FLOWERS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "FITTINGS":
          commit("DIY_FITTINGS", { item: item, index: index });
          commit("DIY_SHOW_IMAGES");
          break;
        default:
          break;
      }
    },
    handleAddSpecPrice({ commit }, specPrice) {
      commit("ADD_SPEC_PRICE", specPrice);
    },
  },
  mutations: {
    [DIY_GROUPS](state, { list, index = "auto" }) {
      list =
        list && list.diyList && list.diyList.length > 0
          ? list
          : state.diyGroups;
      list.diyList &&
        list.diyList.forEach((item, i) => {
          if (index === "auto") {
            if (!item.checked) {
              item.checked = "0";
            }
          } else {
            if (i == index) {
              item.checked = "1";
            } else {
              item.checked = "0";
            }
          }
        });
      state.diyGroups = list;
    },
    [DIY_FLOWERS](state, { list, item = "auto" }) {
      if (item !== "auto") {
        list = state.diyFlowers;
        list.diyList.forEach((it) => {
          if (it.flowerId == item.flowerId) {
            if (it.checked === "1") {
              it.checked = "0";
            } else {
              it.checked = "1";
            }
          } else {
            it.checked = "0";
          }
        });
        // const diyDoors = state.diyDoors;
        // diyDoors.diyList.forEach((itemDoor) => {
        //   if (itemDoor.flowerId == item.flowerId) {
        //     itemDoor.checked = "1";
        //   } else {
        //     itemDoor.checked = "0";
        //   }
        // });
        // state.diyDoors = diyDoors;
      }
      state.diyFlowers = list;
    },
    [DIY_COLORS](state, { list, item = "auto" }) {
      if (item !== "auto") {
        list = state.diyColors;
        list.diyList.forEach((it) => {
          if (it.colorId == item.colorId) {
            if (it.checked === "1") {
              it.checked = "0";
            } else {
              it.checked = "1";
            }
          } else {
            it.checked = "0";
          }
        });
        // const diyDoors = state.diyDoors;
        // diyDoors.diyList.forEach((itemDoor) => {
        //   if (itemDoor.colorId == item.colorId) {
        //     itemDoor.checked = "1";
        //   } else {
        //     itemDoor.checked = "0";
        //   }
        // });
        // state.diyDoors = diyDoors;
      }
      state.diyColors = list;
    },
    [DIY_FITTINGS](state, { list, item, index = "auto" }) {
      if (index != "auto") {
        list = state.diyFittings;
        list.forEach((itemS) => {
          if (item.diyName === itemS.diyName) {
            itemS.diyList.forEach((itemX, idx) => {
              if (idx == index) {
                if (itemX.checked === "1") {
                  itemX.checked = "0";
                } else {
                  itemX.checked = "1";
                }
              } else {
                itemX.checked = "0";
              }
            });
          }
        });
      }
      state.diyFittings = list;
    },
    [DIY_DOORS](state, { list, item = "auto" }) {
      if (item !== "auto") {
        list = state.diyDoors;
        list.diyList.forEach((it) => {
          if (it.doorInstId == item.doorInstId) {
            it.checked = "1";
          } else {
            it.checked = "0";
          }
        });
        // console.log("list", list);
        // const diyFlowers = state.diyFlowers;
        // diyFlowers.diyList.forEach((itemF) => {
        //   if (itemF.flowerId == item.flowerId) {
        //     itemF.checked = "1";
        //   } else {
        //     itemF.checked = "0";
        //   }
        // });
        // const diyColors = state.diyColors;
        // diyColors.diyList.forEach((itemC) => {
        //   if (itemC.colorId == item.colorId) {
        //     itemC.checked = "1";
        //   } else {
        //     itemC.checked = "0";
        //   }
        // });
        // state.diyFlowers = diyFlowers;
        // state.diyColors = diyColors;
      }

      state.diyDoors = list;
    },
    [DIY_SHOW_IMAGES](state) {
      const diyDoors = state.diyDoors || {};
      const diyFittings = state.diyFittings || [];
      const images = [];
      const finalSelect = {
        doorInstMsg: {},
        specs: [],
        fittings: [],
      };
      diyDoors.diyList &&
        diyDoors.diyList.forEach((itemDoor) => {
          itemDoor.imageIndex = 9;
          if (itemDoor.checked === "1") {
            images.push(itemDoor);
            finalSelect.doorInstMsg = itemDoor;
          }
        });
      diyFittings.forEach((item) => {
        item.diyList.forEach((itemFit) => {
          itemFit.imageIndex = 10;
          if (itemFit.checked === "1") {
            images.push(itemFit);
            finalSelect.fittings.push(itemFit);
          }
        });
      });
      const lastImages = images.map((item) => {
        let madeClass = "";
        if (item.mxoffset || item.myoffset) {
          const mxoffset = Number(item.mxoffset);
          const myoffset = Number(item.myoffset);
          const arr = [];
          arr.push(`z-index:${item.imageIndex}`);
          if (mxoffset < 0) {
            arr.push(`right:${-mxoffset}px`);
          } else {
            arr.push(`left:${mxoffset}px`);
          }
          if (myoffset < 0) {
            arr.push(`top:${-myoffset}px`);
          } else {
            arr.push(`bottom:${myoffset}px`);
          }
          madeClass = arr.join(";");
        }
        item.madeClass = madeClass;
        return item;
      });
      state.diyShowImages = lastImages;
      state.finalSelect = finalSelect;
    },
    [GOOD_DETAIL](state, detail) {
      state.goodsDetails = detail;
    },
    [ADD_SPEC_PRICE](state, specPrice) {
      const diyPriceSelected = [];
      const diyFittings = state.diyFittings || [];
      diyFittings.forEach((item) => {
        item.diyList.forEach((itemFit) => {
          itemFit.imageIndex = 10;
          if (itemFit.checked === "1") {
            diyPriceSelected.push(itemFit);
          }
        });
      });
      let diyTotalPrice = 0;
      diyPriceSelected.forEach((item) => {
        diyTotalPrice += Number(item.price);
      });
      console.log("specPrice", specPrice);
      state.diyTotalPrice = diyTotalPrice + specPrice;
    },
  },
  getters: {
    diyGroups: (state) => {
      return state.diyGroups;
    },
    diyFlowers: (state) => {
      return state.diyFlowers;
    },
    diyColors: (state) => {
      return state.diyColors;
    },
    diyDoors: (state) => {
      return state.diyDoors;
    },
    diyShowImages: (state) => {
      return state.diyShowImages;
    },
    diyTotalPrice: (state) => {
      return state.diyTotalPrice;
    },
    finalSelect: (state) => {
      return state.finalSelect;
    },
    diyFittings: (state) => {
      return state.diyFittings;
    },
    goodsDetails: (state) => {
      return state.goodsDetails;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/diy/index.js